<app-widget-base [title]="title">
  <p class="total" *ngIf="!this.isMultiple && total != null">
    {{ total | hideZeroValues : '1.0-0' }}
  </p>
  <div class="total" *ngIf="this.isMultiple && total != null">
    <p *ngFor="let t of getComparisonTotals()">
      {{ t | hideZeroValues : '1.0-0' }}
    </p>
  </div>
  <div #tooltip class="tooltip hidden">
    <div class="content">
      <p>
        <span class="name"></span>
      </p>
      <p>
        <span class="value"></span>
        <small> {{ usePerc ? '%' : (tooltipSuffix | translate) }}</small>
      </p>
      <p *ngIf="isVisitsAvailable && stats">
        <span class="value-percentage"></span>&nbsp;<small>{{
          'over the total of' | translate
        }}</small
        >&nbsp;<small> {{ tooltipSuffix | translate }}</small>
      </p>
    </div>
  </div>
  <svg #svg></svg>
</app-widget-base>
